export default "__VITE_ASSET__Ba_AQiIl__"